/**
 * Hide discount code input ONLY when the "ambassadeur" product (Pack de 3) is in the cart.
 * Handle: ambassadeur | Product ID: 15889137140092
 * v2 - 2026-02-11
 */
(function () {
  var BLOCKED_HANDLE = 'ambassadeur';
  var BLOCKED_PRODUCT_ID = 15889137140092;

  function setDiscountVisibility(hide) {
    document.querySelectorAll('cart-discount').forEach(function (el) {
      if (hide) {
        el.style.display = 'none';
      } else {
        el.style.removeProperty('display');
      }
    });
  }

  function checkCart() {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var found = cart.items.some(function (item) {
          return item.handle === BLOCKED_HANDLE || item.product_id === BLOCKED_PRODUCT_ID;
        });
        setDiscountVisibility(found);
      })
      .catch(function () {});
  }

  /* Run check on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCart);
  } else {
    checkCart();
  }

  /* Re-check when cart drawer refreshes (after AJAX re-render) */
  document.addEventListener('cart-drawer:refresh', function () {
    setTimeout(checkCart, 300);
  });

  /* Intercept fetch calls to cart endpoints */
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var isCartChange = typeof url === 'string' && /\/cart\/(add|change|update|clear)/i.test(url);
    var result = originalFetch.apply(this, arguments);
    if (isCartChange) {
      result.then(function () {
        setTimeout(checkCart, 500);
      }).catch(function () {});
    }
    return result;
  };

  /* Intercept XMLHttpRequest for older cart implementations */
  var originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    var url = arguments[1];
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/i.test(url)) {
      this.addEventListener('load', function () {
        setTimeout(checkCart, 500);
      });
    }
    return originalXHROpen.apply(this, arguments);
  };
})();
